import React from 'react';
import PropTypes from 'prop-types'

import './ticketLayout.scss';

/**
 * The TicketLayout component.
 */
export class TicketLayout extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    return (
      <div className="ticket-layout">
        <div id="main-container" className="container" role="main">
          <div className="row">
            <div className="small-12">
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TicketLayout.propTypes = {
  children: PropTypes.element,
  location: PropTypes.object,
  state: PropTypes.object,
};

export default TicketLayout;



// WEBPACK FOOTER //
// ./src/components/layouts/ticketLayout/TicketLayout.js